import { ADFOX_CODES_DESKTOP } from '~/components/Adfox';
import { presets as companyNewsPresets } from '~/composables/grid/company-news';
import { presets as rubricPresets } from '~/composables/grid/rubric';
import { presets as tagPresets } from '~/composables/grid/tag';
/**
 * Lists for injecting in grid
 */
export const INJECTABLE_LISTS = (path) => {
    return {
        rubric: {
            [`${path}-partner`]: {
                'slider:rubric-partner': true,
                'slider-mobile:rubric-partner': true,
            },
            [`${path}-news`]: {
                'slider:interesting-today': true,
                'slider-mobile:interesting-today': true,
            },
        },
        rubricCompanyNews: {
            'interesting-today': {
                'slider:interesting-today': true,
                'slider-mobile:interesting-today': true,
            },
        },
        tag: {
            'interesting-today': {
                'slider:interesting-today': true,
                'slider-mobile:interesting-today': true,
            },
        },
        tagEducation: {
            'forbes-ontology-main': {
                'slider:interesting-today': true,
                'slider-mobile:interesting-today': true,
            },
        },
        rubricEducation: {
            'interesting-today': {
                'slider:interesting-today': false,
                'slider-mobile:interesting-today': false,
            },
        },
    };
};
/**
 * Grid presets
 */
export const PRESETS = {
    rubric: rubricPresets,
    rubricCompanyNews: companyNewsPresets,
    tag: tagPresets,
};
/**
 * Social links types
 */
export const SOCIAL_LINKS_TYPES = {
    '/forbeslife': 'forbeslife',
    '/forbes-woman': 'forbes-woman',
    '/young': 'young',
};
/**
 * Article sidebar items
 */
export const ARTICLE_SIDEBAR_ITEMS = createSidebarItems([
    {
        component: () => import('~/components/Adfox/Adfox.vue'),
        config: ADFOX_CODES_DESKTOP['300x600_1'],
        containerHeight: 900,
        height: 600,
        isSticky: true,
        name: '300x600_1',
        // background: ADFOX_CODES_DESKTOP.background,
    },
    {
        component: () => import('~/components/AdfoxInformer/AdfoxInformer.vue'),
        config: ADFOX_CODES_DESKTOP.informer_1,
        containerHeight: 224,
        height: 200,
        name: 'informer_1',
    },
    {
        component: () => import('~/components/AdfoxInformer/AdfoxInformer.vue'),
        config: ADFOX_CODES_DESKTOP.informer_2,
        containerHeight: 224,
        height: 200,
        name: 'informer_2',
    },
    {
        component: () => import('~/components/AdfoxInformer/AdfoxInformer.vue'),
        config: ADFOX_CODES_DESKTOP.informer_3,
        containerHeight: 224,
        height: 200,
        name: 'informer_3',
    },
    {
        component: () => import('~/components/AdfoxInformer/AdfoxInformer.vue'),
        config: ADFOX_CODES_DESKTOP.informer_4,
        containerHeight: 224,
        height: 200,
        name: 'informer_4',
    },
    {
        component: () => import('~/components/Adfox/Adfox.vue'),
        config: ADFOX_CODES_DESKTOP['300x600_2'],
        containerHeight: 900,
        height: 600,
        isSticky: true,
        name: '300x600_2',
    },
    {
        component: () => import('~/components/RotatingBanner/RotatingBanner.vue'),
        config: ADFOX_CODES_DESKTOP['300x600_3'],
        containerHeight: 900,
        height: 600,
        isSticky: true,
        name: '300x600_3',
    },
]);
/**
 * Create sidebar adfox items
 */
export function createSidebarItems(items, callback = () => false) {
    const originalItems = [...items];
    return JSON.parse(JSON.stringify(items)).map((item, i) => {
        const defaultItem = originalItems.find(({ name }) => name === item.name) || {};
        item.id = i.toString();
        // Recover dynamic imports
        item.component = defaultItem.component;
        // Do something else with item
        if (callback) {
            callback(item);
        }
        return item;
    });
}
